"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PipelineProxy = void 0;
const guard_1 = require("../utils/guard");
const PipelineItem_1 = require("./PipelineItem");
/**
 * A pipeline that combies multiple resilience proxies.
 */
class PipelineProxy {
    /**
     * Initializes a new instance of the @see Pipeline class.
     * @param proxies A ordered list of proxies to create the pipeline from.
     */
    constructor(proxies) {
        guard_1.Guard.throwIfNullOrEmpty(proxies, 'proxies');
        this.start = this.generatePipeline(proxies);
    }
    /**
     * Executes a function within a resilience proxy.
     * @param func Function to execute within the resilience proxy.
     * @param requestId Request Guid.
     */
    execute(func, requestId) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.start.execute(func, requestId);
            return result;
        });
    }
    /**
     * Generates the pipeline from the proxies.
     * @param proxies Proxies to use.
     * @returns A resilience pipeline.
     */
    generatePipeline(proxies) {
        const reversed = proxies.reverse();
        let previous = null;
        for (const proxy of reversed) {
            const current = new PipelineItem_1.PipelineItem(proxy, previous);
            previous = current;
        }
        return previous;
    }
}
exports.PipelineProxy = PipelineProxy;
//# sourceMappingURL=pipelineProxy.js.map